import cn from 'clsx';
import { FC } from 'react';

import s from '../Modal/Modal.module.scss';

const DialogSubtext: FC<React.PropsWithChildren<React.PropsWithChildren<{ subtext: string; subtextType: 'default' | 'small' }>>> = ({
  subtext,
  subtextType
}) => {
  return (
    <div
      className={cn(s.header__subtext, {
        [s['header__subtext--default'] as string]: subtextType === 'default',
        [s['header__subtext--small'] as string]: subtextType === 'small'
      })}
    >
      {subtext}
    </div>
  );
};

export default DialogSubtext;
